import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { select, Store } from '@ngrx/store';
import { SelectOptionLoaderI } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-select/models/select-option-loader-i';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { SelectOptionI } from '../../../../../../shared/modules/configurable-form/components/form-select/models/select-option-i';
import { OrderBuilderState } from '../../../../../reducers';
import { getAvailablePaymentTerms } from '../../../selectors/contracts.selectors';
import { SpecFieldNames } from '@ordersnproducts/modules/order-builder/modules/specification/constants/specification-field-names.enum';
@Injectable()
export class PaymentTermsOptionLoaderService implements SelectOptionLoaderI {
  constructor(private store: Store<OrderBuilderState>) {}

  /**
   * Provides an observable of paymentTerms
   * @return {Observable<SelectOptionI[]>}
   */
  loadOptions(formGroup: UntypedFormGroup): Observable<SelectOptionI[]> {
    return this.store.pipe(
      select(getAvailablePaymentTerms),
      filter((data) => !!data),
      map((availablePaymentTerms) => {
        if (availablePaymentTerms && availablePaymentTerms.length) {
          formGroup.get(SpecFieldNames.PAYMENT_TERMS).setValue(availablePaymentTerms[0].paymentTermCode);
          return availablePaymentTerms.map((paymentTerm) => {
            return {
              id: paymentTerm.paymentTermCode,
              name: `${paymentTerm.paymentTermDesc}`,
            };
          });
        }
        return [];
      }),
    );
  }
}
